import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Table from "react-bootstrap/Table";
import { PaginationControl } from "react-bootstrap-pagination-control";
import { AxisDateTimeFull } from "../util/AxisDateTime";
import { ShiftTypeString } from "../util/ShiftOptionsSelection";
import { ShiftLink, UserLink } from "../util/Links";
import { ShiftTableDetailModal } from "../modals/ShiftTableDetailModal";

const UserShiftCancels = ({ user }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [offset, setOffset] = useState(0);
  const [totalShifts, setTotalShifts] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [fetchCount, setFetchCount] = useState(25);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectDetail, setSelectDetail] = useState(null);

  useEffect(() => {
    paginateShifts();
  }, [offset, user]);

  const closeDetailModal = () => {
    setDetailModalVisible(false);
    setSelectDetail(null);
  };

  const openDetailModal = (shift) => {
    setSelectDetail(shift);
    setDetailModalVisible(true);
  };

  const paginateShifts = async () => {
    try {
      setLoading(true);

      var params = {
        user_id: user?.id,
      };

      const pageSettings = {
        direction: "dsc",
        key: "created",
        page: offset,
        elementPerPage: fetchCount,
      };
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const page = await authAxios().post(
        "/api/backoffice/users/cancellations",
        pageSettings,
        config,
      );
      setLoading(false);

      if (page.data.content.length === 0) {
        if (dataSource.length === 0) {
          setTotalShifts(0);
        }
        console.log("empty api call");
        setDataSource([]);
        return;
      }

      setDataSource(page.data.content);
      setTotalShifts(page.data.totalElements);
      var length = Math.ceil(page.data.totalElements / fetchCount);
      setTotalPages(length);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };

  return (
    <Fragment>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Reference</th>
            <th>Type</th>
            <th>Trust</th>
            <th>Facility</th>
            <th>Ward</th>
            <th>Grade</th>
            <th>Status</th>
            <th>Reason</th>
            <th>Cancelled By</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {dataSource.map((shift) => (
            <tr key={shift?.id} onClick={() => openDetailModal(shift)}>
              <td>{ShiftLink(shift)}</td>
              <td>{ShiftTypeString(shift?.shiftType)}</td>
              <td>{shift?.trust?.shortName}</td>
              <td>{shift?.facility?.name}</td>
              <td>{shift?.ward?.identifier}</td>
              <td>{shift?.grade}</td>
              <td>{shift?.status}</td>
              <td>{shift?.cancelledShift?.reason}</td>
              <td>
                {shift?.cancelledShift?.cancelledBy?.id !== null &&
                shift?.cancelledShift?.cancelledBy?.id !== undefined
                  ? UserLink(shift?.cancelledShift?.cancelledBy)
                  : "Trust"}
              </td>
              <td>{AxisDateTimeFull(shift?.start)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div>
        <p>
          Page {offset + 1} of {totalPages}, showing {dataSource.length}
          records(s) out of {totalShifts}
        </p>
        <div>
          <PaginationControl
            page={offset + 1}
            between={3}
            total={totalShifts}
            limit={fetchCount}
            changePage={(page) => {
              setOffset(page - 1);
            }}
            ellipsis={1}
          />
        </div>
      </div>
      <ShiftTableDetailModal
        shift={selectDetail}
        close={closeDetailModal}
        visible={detailModalVisible}
      />
    </Fragment>
  );
};

export default UserShiftCancels;
